import DashboardExpandableWidgets from "@/domain/enums/DashboardExpandableWidgets";
import { Store } from "@tanstack/react-store";

const dashboardStore = new Store({
    expandedWidget: null as DashboardExpandableWidgets | null,
});

export const expandWidget = (widget: DashboardExpandableWidgets) => {
    dashboardStore.setState(() => ({ expandedWidget: widget }));
};

export const collapseWidget = () => {
    dashboardStore.setState(() => ({ expandedWidget: null }));
};

export default dashboardStore;
